const {enabled}=require('./transition.js');
const running=new Set(),targets=new WeakMap();
const cover=element=>{
 if(!element)return;
 targets.get(element)?.cancel();
 if(!enabled())return;
 const animation=element.animate([
  {clipPath:'inset(0 0 14% 0)',opacity:.35,transform:'translateY(12px)'},
  {clipPath:'inset(0 0 0 0)',opacity:1,transform:'none'}
 ],{duration:700,easing:'cubic-bezier(.16,1,.3,1)'});
 targets.set(element,animation);running.add(animation);
 const clean=()=>running.delete(animation);animation.onfinish=clean;animation.oncancel=clean;
};
const observer=new IntersectionObserver(entries=>{
 entries.forEach(entry=>{if(entry.isIntersecting){cover(entry.target);observer.unobserve(entry.target);}});
},{threshold:.12});
document.querySelectorAll('.one-projects__visual,.one-projectstrip__image,.one-project-neighbors__image').forEach(element=>observer.observe(element));
addEventListener('onestep:motion',()=>{if(!enabled()){running.forEach(animation=>animation.cancel());running.clear();}});
module.exports={cover};
